export default object => JSON.parse(JSON.stringify(object))